module.exports = __webpack_public_path__ + "fonts/BerninaSans-Bold.984abe89.woff";